import { render, staticRenderFns } from "./CommonAttachment.vue?vue&type=template&id=c897e8dc&scoped=true&"
import script from "./CommonAttachment.vue?vue&type=script&lang=ts&"
export * from "./CommonAttachment.vue?vue&type=script&lang=ts&"
import style0 from "./CommonAttachment.vue?vue&type=style&index=0&id=c897e8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c897e8dc",
  null
  
)

export default component.exports